import React, { useState } from "react";
import {
  IconTitleDescriptionActionCard,
  SectionContainerBase,
  TwoColumnSectionBase,
} from "@reusejs/react";
import ContactUsForm from "./ContactUsForm";

export default function GetInTouch(props: any) {
  const [formSubmittedFlag, setFormSubmittedFlag] = useState(false);

  let sectionHeader = {
    title: "Get in touch",
    description: formSubmittedFlag
      ? "Your query has been submitted. We will get back to you"
      : "Fill out the form and send it to us for more enquiries. We’ll get back to you.",
  };

  return (
    <SectionContainerBase
      sectionContainerBaseClasses={{
        outerContainerStyles: "py-12 md:py-24",
        innerContainerStyles: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 xl:px-0",
      }}
    >
      <TwoColumnSectionBase
        firstColumnEl={
          <IconTitleDescriptionActionCard
            title={sectionHeader.title}
            description={sectionHeader.description}
            itemTitleDescriptionCardBaseClasses={{
              titleWrapper: "mt-2 text-center",
              titleStyles: "text-xl md:text-4xl font-extrabold leading-6",
              descriptionWrapper: "text-center mt-3 lg:mt-4 max-w-2xl mx-auto",
              descriptionStyles:
                "text-base md:text-lg text-gray-500 font-normal",
            }}
          />
        }
        secondColumnEl={
          !formSubmittedFlag && (
            <ContactUsForm
              flag={formSubmittedFlag}
              setFlag={setFormSubmittedFlag}
            />
          )
        }
        twoColumnSectionBaseClasses={{
          firstElWrapperStyles: "w-full",
          secondElWrapperStyles: "w-full max-w-3xl h-full pt-8 md:pt-16",
          columnsFlexWrapperStyles:
            "flex items-center justify-between flex-col",
        }}
      />
    </SectionContainerBase>
  );
}
